import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.scss']
})
export class TextBoxComponent implements OnInit {

  @Input() header: string = null;
  @Input() button: { [key: string]: string };

  constructor() { }

  ngOnInit(): void {
  }

}
